import React from 'react';

const CompanyLogos: React.FC = () => {
  const companies = [
    'Attentive',
    'Square',
    'Splunk',
    'Ghost',
    'Uber',
    'WealthSimple',
    'Twitch',
    'Upwork',
    'Plaid'
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <p className="text-center text-gray-600 mb-8">You're in good company</p>
      <div className="grid grid-cols-3 md:grid-cols-5 gap-8 items-center justify-items-center">
        {companies.map((company, index) => (
          <div key={index} className="text-gray-400 font-semibold">
            {company}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyLogos;
